import { Box, Text, Menu, Tooltip, Loader } from "@mantine/core";
import { IconBell } from "@tabler/icons-react";
import { useUpdatesForUser } from "../../../../../api/tickets/useUpdatesForUser";
import CircleContainer from "../CircleContainer";
import TicketsPreview from "./components/TicketsPreview/TicketsPreview";
import classes from "./styles.module.scss";
import clsx from "clsx";

function Notifications() {
  const { data, isPending } = useUpdatesForUser();
  return (
    <Menu
      trigger="hover"
      classNames={{ dropdown: classes.dropdown }}
      disabled={!data?.length}
    >
      <Menu.Target>
        <Tooltip
          label="Du har inga olästa notiser"
          disabled={!!data?.length}
          openDelay={500}
        >
          <Box>
            <CircleContainer>
              <IconBell color="white" size={20} />
              <div
                className={clsx({
                  [classes.messageCount]: true,
                  [classes.hasNewMessages]: data?.length,
                })}
              >
                {isPending ? (
                  <Loader size={12} color="bluegray.7" />
                ) : (
                  <Text fw={700} fz={10} c="bluegray.9">
                    {data?.length}
                  </Text>
                )}
              </div>
            </CircleContainer>
          </Box>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <TicketsPreview />
      </Menu.Dropdown>
    </Menu>
  );
}

export default Notifications;
